import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import NewsItem from './NewsItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
    newsContainer: {
        padding: '2.25em',
        paddingTop: '1.75em',
        paddingBottom: '2.4375em',
        marginTop: '4.375em',
        marginBottom: '4.25em'
    },
    newsContainerMobile: {
        paddingTop: '1.75em',
        paddingBottom: '2.4375em',
        marginTop: '4.375em',
        marginBottom: '4.25em',
    },
    title: {
        fontSize: '2.125em',
        fontWeight: 'bold',
        letterSpacing: '0.0358em',
        lineHeight: 1.353,
        color: 'white'
    },
    newsInnerContainer: {
        display: 'flex',
    },
    hidden: {
        display: 'none'
    },
    moreButton: {
        fontFamily: 'Roboto',
        marginTop: '2.75em',
        letterSpacing: '0.031em'
    },
});

interface NewsItemProps {
    title: string;
    content: string;
    link: string;
    readMore: string;
}

interface NewsContainerProps {
    newsItems: NewsItemProps[];
}

interface MobileViewProps {
    isMobileDevice: boolean | undefined;
}

type Props = MobileViewProps & NewsContainerProps

class NewsContainer extends React.Component<WithStyles & Props, { open: boolean; }> {
    constructor(props: WithStyles & Props) {
        super(props);
        this.state = {
            open: false
        };
    }

    public render() {
        const {
            classes,
            newsItems
        } = this.props;
        const { open } = this.state;
        const buttonLabel = open ? localizations.newsContainer.hideNews : localizations.newsContainer.moreNews;
        return (
            <Grid item container direction="column" alignItems="center" className={this.props.isMobileDevice === false ? classes.newsContainer : classes.newsContainerMobile}>
                <Grid item className={classes.title}>{localizations.newsContainer.unitSpotterinMedia}</Grid>
                {this.props.isMobileDevice === false ?
                    <Grid item container>
                        {newsItems.slice(0, 3).map((item, index) => (
                            <NewsItem key={`news_item_${index}`} title={item.title}  content={item.content} link={item.link} readMore={item.readMore} />
                        ))}
                    </Grid> :
                    <Grid item container>
                        {newsItems.slice(0, 1).map((item, index) => (
                            <NewsItem key={`news_item_${index}`} title={item.title}  content={item.content} link={item.link} readMore={item.readMore} />
                        ))}
                    </Grid>}
                {newsItems.length > 3 ? (
                    <React.Fragment>
                        <Grid item className={open ? classes.newsInnerContainer : classes.hidden}>
                            {newsItems.slice(3).map((item, index) => (
                                <NewsItem key={`news_item_${index}`} title={item.title}  content={item.content} link={item.link} readMore={item.readMore} />
                            ))}
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="secondary" className={classes.moreButton} onClick={this.toggleOpen}>
                                {buttonLabel}
                            </Button>
                        </Grid>
                    </React.Fragment>
                ) : null}
            </Grid>
        );
    }

    private toggleOpen = () => this.setState({ open: !this.state.open });
}

export default withStyles(styles)(NewsContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/NewsContainer.tsx